import { createSlice } from '@reduxjs/toolkit'

const forgottenPasswordSlice = createSlice({
    name: 'forgotten-password',
    initialState: { error: null, loading: false, success: false },
    reducers: {
        forgottenPassword() {},
    },
})

const { actions, reducer } = forgottenPasswordSlice

export const { setLoading, setError, setSuccess, forgottenPassword } = actions

export default reducer
